import { useEffect } from "react";

/**
 * Ajuste la hauteur de l'iframe parent Sonata pour éviter que le contenu (menus react-select…) soit coupé.
 */
export const useIframeAutoHeight = (deps = []) => {
  useEffect(() => {
    const prevBodyOverflow = document.body.style.overflow;
    const prevHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = "visible";
    document.documentElement.style.overflow = "visible";

    const notifyParent = () => {
      const height = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight,
        document.documentElement.offsetHeight
      );
      const parentOrigin = process.env.REACT_APP_LEMOULIN_BO_URL;
      if (parentOrigin && window.parent !== window) {
        window.parent.postMessage({ type: "suggestions_iframe_resize", height }, parentOrigin);
      }
    };

    notifyParent();
    const t1 = setTimeout(notifyParent, 300);
    const t2 = setTimeout(notifyParent, 1000);
    window.addEventListener("resize", notifyParent);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      window.removeEventListener("resize", notifyParent);
      document.body.style.overflow = prevBodyOverflow;
      document.documentElement.style.overflow = prevHtmlOverflow;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useIframeAutoHeight;
